import { render, staticRenderFns } from "./DataTableConversation.vue?vue&type=template&id=2e619942&scoped=true&"
import script from "./DataTableConversation.vue?vue&type=script&lang=js&"
export * from "./DataTableConversation.vue?vue&type=script&lang=js&"
import style0 from "./DataTableConversation.vue?vue&type=style&index=0&id=2e619942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e619942",
  null
  
)

export default component.exports